import { graphql, useStaticQuery } from "gatsby"

import { useLocale } from "../../../../utils/hooks/use-locale"

export type Category = "solutions" | "product" | "catalog" | "resources"

type Feature = {
  title: string
  description: string
  linkText: string
  linkUrl: string
  thumbnail: {
    url: string
  }
}

type FeaturedContentQuery = {
  datoCms: {
    featuredContent: {
      [key in Category]: {
        locale: string
        value: Feature[]
      }[]
    }
  }
}

export const useFeaturedContent = (category: Category) => {
  const locale = useLocale()
  const {
    datoCms: { featuredContent },
  } = useStaticQuery<FeaturedContentQuery>(graphql`
    query FeaturedContentQuery {
      datoCms {
        featuredContent {
          solutions: _allSolutionsFeatureLocales {
            locale
            value {
              title
              description
              linkText
              linkUrl
              thumbnail {
                url
              }
            }
          }
          product: _allProductFeatureLocales {
            locale
            value {
              title
              description
              linkText
              linkUrl
              thumbnail {
                url
              }
            }
          }
          catalog: _allCatalogFeatureLocales {
            locale
            value {
              title
              description
              linkText
              linkUrl
              thumbnail {
                url
              }
            }
          }
          resources: _allResourcesFeatureLocales {
            locale
            value {
              title
              description
              linkText
              linkUrl
              thumbnail {
                url
              }
            }
          }
        }
      }
    }
  `)

  const categoryLocales = featuredContent[category]
  const categoryItem = categoryLocales.find(item => item.locale === locale)

  if (!categoryItem) {
    throw new Error(
      `Featured content for ${category} is not available in language: ${locale}`,
    )
  }

  return categoryItem.value[0]
}
